import { AtgardStatusBase, IAtgardStatus, IAtgardStatusTooltip } from "./atgardheadericons-models";

export class DrivningspunkterAtgardStatus extends AtgardStatusBase implements IAtgardStatus {
    header = "Drivningspunkter";
    tooltips = [
        {
            header: "Endast en larmkoordinat:",
            text: this.status.larmPunkterCount === 1 ? "Ja" : "Nej",
            visible: true
        } as IAtgardStatusTooltip,
{
    header: "Minst ett avlägg. Alla avlägg ska ha tillgänglighetsklass: ",
    text: this.avlaggValid() === true ? "Ja" : "Nej",
    visible: true
} as IAtgardStatusTooltip
    ];
    icons = [
        {
            visible: true,
            iconclass1: "far fa-map-marker-alt",
            incomplete: !this.drivningspunkterValid(),
            warning: false
        }
    ];
    visible(): boolean {
        return this.status.avlaggCount > 0 || this.status.larmPunkterCount > 0;
    }
    drivningspunkterValid(): boolean {
        return this.avlaggValid() && this.status.larmPunkterCount === 1;
    }
    avlaggValid(): boolean {
        return this.status.avlaggCount > 0 &&
               this.status.avlaggAllTillganglighetsklass === true;
    }
}
